import Loadable from '@townsquare/loadable';

export const TeamsApp = Loadable({
	loader: () => import(/* webpackChunkName: "goals-app-entry" */ '@townsquare/teams/app'),
	loading: () => null,
});
